"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackLastTouchpoint = void 0;
const pushToDataLayer_1 = require("./pushToDataLayer");
function trackLastTouchpoint(lastTouchpoint) {
    (0, pushToDataLayer_1.pushToDataLayer)({ lastTouchpoint });
}
exports.trackLastTouchpoint = trackLastTouchpoint;
//# sourceMappingURL=trackLastTouchpoint.js.map